import { Breadcrumb } from "antd";
import { UIMatch, useMatches, useLocation, Link } from "react-router-dom";

import {
  isUIMatchWithHandle,
  UIMatchWithHandle,
} from "../utils/reactRouterHelper";

/**
 * Render a single breadcrumb.
 *
 * If it's the final node, render the title as plain text. Else, render it as a link.
 */
const BreadcrumbItem = ({
  match,
  currentPath,
}: {
  match: UIMatchWithHandle;
  currentPath: string;
}) => {
  // Pass in the params to the crumb function to get e.g. the ID of an error
  const crumb = match.handle.crumb(match.params);

  if (currentPath === match.pathname) {
    return <span>{crumb.title}</span>;
  } else {
    return (
      <Breadcrumb.Item>
        <Link to={match.pathname}>{crumb.title}</Link>
      </Breadcrumb.Item>
    );
  }
};

const Breadcrumbs = () => {
  const location = useLocation();
  const initialMatches: UIMatch[] = useMatches();
  const matches = initialMatches.filter(isUIMatchWithHandle);

  return (
    <Breadcrumb>
      {matches.map((match, index) => (
        <BreadcrumbItem
          key={index}
          match={match}
          currentPath={location.pathname}
        />
      ))}
    </Breadcrumb>
  );
};

export default Breadcrumbs;
